import { CurrencyInput } from './number-input/currency-input.component';
import type { InputProps } from './types';

export const MoneyInput = (props: InputProps<'money'>) => <CurrencyInput {...props} />;
